import React, { useState, useEffect, useRef, useCallback } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate, useLocation } from "react-router-dom";
import isEqual from "lodash/isEqual";

//API
import ItemService from "../../../../services/supplier_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import {
  getCurrentDate,
  isValidNumber,
  validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import SericesSchedulePO from "../../../../Components/Modal/supplier_app/PO_Collabration/SericesSchedulePO";
import Loader from "../../../../Components/Loader";
import AlertNotifications from "../../../../Components/AlertNotifications/AlertNotifications";
// eslint-disable-next-line
import { getPurchaseRequisition } from "../../../../redux/feature/supplier_app/sourcingSlice";
import MaterialSelectionModal from "../../POCollabration/PO/MaterialSelectionModal";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";

import {
  getpurchaseGroup1,
  getCostCenterOptions,
  getGLAccountOptions,
  getPriorityOptions,
  getBusinessUnitOptions,
  getDeliveryAddressOptions,
} from "./PRConstant";

const REQUIRED_MSG = "Please fill the required field";

const CreatePR = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { draftId: draftIdParam, newDraft: newDraftParam } =
    location.state || {};
  // eslint-disable-next-line
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Purchase Requisition");

  let purchaseDocType = useSelector((state) => state?.sourcing.purchaseDocType);
  let purchaseDocCode = useSelector((state) => state?.sourcing.purchaseDocCode);
  let userData = useSelector((state) => state?.user); // User Details from Store

  const [currentDate] = useState(getCurrentDate("default"));
  // JSON Object
  const [formInputs, setFormInputs] = useState({
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName,
    initiator: userData?.data?.userId,
    purchasingReqDocumentType: purchaseDocType,
    purchasingReqDocumentCode: purchaseDocCode,
    version: "V0",
    prStatusHeader: "In Release",

    vendorCode: "",
    vendorName: "",
    procurementCategory: "",
    purchasingReqDocumentDate: currentDate,
    purchasingOrg: "",
    purchasingGroup: "",
    companyCode: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    incoTerms: "",
    incoTermsCode: "",
    incoTermsLocation: "",
    purchasingReqDocumentValue: "",
    purchasingDocumentTaxTotalValue: "",
    purchasingDocumentItemTotalValue: "",
    purchasingReqRemark: "",
    headerTextData: [],
    // headerTextData: [
    //   {
    //     itemIndex: "",
    //     documentId: "",
    //     documentText: "",
    //   },
    // ],

    items: [],

    costCenter: "",
    costCenterCode: "",
    businessUnit: "",
    businessUnitCode: "",
    budgetAvailability: "Yes",
    businessJustification: "",
    priority: "",
    priorityCode: "",
    glAccount: "",
    glAccountCode: "",
    deliveryAddress: "",
  });

  const [validation, setValidation] = useState({});
  // { [local_id]: { purchaseQuantity: "...", orderUnitOfMeasure: "...", deliveryDate: "..." } }
  const [lineItemErrors, setLineItemErrors] = useState({});

  const [vendorList, setVendorList] = useState([]);

  const createEmptyFormInputs = () => ({
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName || "",
    initiator: userData?.data?.userId || "",
    purchasingReqDocumentType: purchaseDocType || "",
    purchasingReqDocumentCode: purchaseDocCode || "",
    version: "V0",
    prStatusHeader: "In Release",

    vendorCode: "",
    vendorName: "",
    procurementCategory: "",
    purchasingReqDocumentDate: currentDate,
    purchasingOrg: "",
    purchasingGroup: "",
    companyCode: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    incoTerms: "",
    incoTermsCode: "",
    incoTermsLocation: "",
    purchasingReqDocumentValue: "",
    purchasingReqRemark: "",
    headerTextData: [],
    // headerTextData: [
    //   {
    //     itemIndex: "",
    //     documentId: "",
    //     documentText: "",
    //   },
    // ],
    items: [],
    costCenter: "",
    costCenterCode: "",
    businessUnit: "",
    businessUnitCode: "",
    budgetAvailability: "Yes",
    businessJustification: "",
    priority: "",
    priorityCode: "",
    glAccount: "",
    glAccountCode: "",
    deliveryAddress: "",
    // these will be set later when draft loads or when user interacts
    completionPercentage: 0,
  });

  const modalData = {
    title: "PO Creation",
    successMsg: "",
  };

  const [getCurrencyDropdown, setCurrencyDropdown] = useState([]);
  // const [getLoader, setLoader] = useState(true);

  // State
  const [draftData, setDraftData] = useState(null);
  const [loadingDrafts, setLoadingDrafts] = useState(true);

  const calculateDraftProgress = (formData) => {
    let score = 0;

    // 1. Purchase Type (10%)
    if (formData.purchaseType) score += 10;

    // 2. Payment Terms (10%)
    if (formData.paymentTerms) score += 10;

    // 3. At least one line item exists (20%)
    const items = formData.items || [];
    if (items.length > 0) {
      score += 20;

      const firstItem = items[0];
      // 4. Material Code (15%)
      if (firstItem.materialCode) score += 15;
      // 5. Quantity (15%)
      if (firstItem.purchaseQuantity) score += 15;
      // 6. Unit Price (15%)
      if (firstItem.orderPriceUnit) score += 15;
      // 7. Delivery Date (15%)
      if (firstItem.deliveryDate) score += 15;
    }

    return Math.min(score, 100); // cap at 100
  };

  // Inital Create PO
  let POLineItemInitialCol = [
    {
      name: "Sl",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "60px",
    },
    // {
    //   name: "Item Text",
    //   selector: (row) => row.local_id || "--",
    //   sortable: true,
    //   width: "110px",
    //   cell: (row) => (
    //     <>
    //       <span
    //         style={{ marginLeft: "12px" }}
    //         onClick={() =>
    //           showLineItemHeaderText(row.local_id, row.itemTextData)
    //         }
    //       >
    //         <i className="bi bi-calendar2-week iconTable"></i>
    //       </span>
    //       <span className="suppliersIcon">
    //         {" "}
    //         {row.itemTextData?.length || 0}{" "}
    //       </span>
    //     </>
    //   ),
    // },
    {
      name: "Item/Service Code",
      selector: (row) => row.materialCode || "--",
      // cell: (row) => (
      //   <InputField
      //     className="inputBox mt-1"
      //     // label="Please Enter the Remarks*"
      //     name="materialCode"
      //     placeholder=""
      //     value={row.materialCode || ""}
      //     onChange={(event) => handleInputChange(row.local_id, event)}
      //     disabled={true}
      //   />
      // ),
      sortable: true,
      width: "165px",
    },
    {
      name: "Name",
      selector: (row) => row.materialDescription || "--",
      // cell: (row) => (
      //   <TextAreaField
      //     className="inputBox mt-1"
      //     name="materialDescription"
      //     placeholder=""
      //     value={row.materialDescription || ""}
      //     onChange={(event) => handleInputChange(row.local_id, event)}
      //     disabled={true}
      //   />
      // ),
      sortable: true,
      wrap: true,
      width: "160px",
    },
    {
      name: "Specification",
      selector: (row) => row.specification || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="specification"
          placeholder=""
          value={row.specification || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Category",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Sub-Category",
      selector: (row) => row.subCategory || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="subCategory"
          placeholder=""
          value={row.subCategory || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          error={lineItemErrors[row.local_id]?.purchaseQuantity}
        />
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.orderUnitOfMeasure}
        />
      ),
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          error={lineItemErrors[row.local_id]?.orderPriceUnit}
        />
      ),
      width: "120px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "120px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "100px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "125px",
    },
    {
      name: "Tax %",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.deliveryDate}
        />
      ),
      width: "180px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.plant}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Prefered  Venodor",
      selector: (row) => row.preferedVendor || "--",
      cell: (row) => (
        <select
          className="form-select inputBox mt-1"
          name="preferedVendor"
          value={row.preferedVendor || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        >
          <option value="">Select Vendor</option>
          {vendorList.map((vendor) => (
            <option key={vendor._id} value={vendor.name}>
              {vendor.name}
            </option>
          ))}
        </select>
      ),
      width: "200px",
    },
    {
      name: "Suggested Vendor",
      selector: (row) => row.suggestedVendor || "--",
      cell: (row) => (
        <select
          className="form-select inputBox mt-1"
          name="suggestedVendor"
          value={row.suggestedVendor || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        >
          <option value="">Select Vendor</option>
          {vendorList.map((vendor) => (
            <option key={vendor._id} value={vendor.name}>
              {vendor.name}
            </option>
          ))}
        </select>
      ),
      width: "200px",
    },
    {
      name: "Last Supplier",
      selector: (row) => row.lastSupplierName || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="lastSupplierName"
          placeholder="Last Supplier"
          value={row.lastSupplierName || ""}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Last Purchase Rate",
      selector: (row) => row.lastPurchaseRate || "",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="lastPurchaseRate"
          placeholder="Last Purchase Rate"
          value={row.lastPurchaseRate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      width: "175px",
    },
    {
      name: "Attachment",
      selector: (row) => row.attachmentId || "--",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <FileUploadComponentForHB
            label=""
            name="attachmentId"
            allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
            multiple={false}
            value={row.attachmentId || ""}
            onSuccessUpload={(payload) => {
              setPOLineItemsData((prevRows) =>
                prevRows.map((r) =>
                  r.local_id === row.local_id
                    ? { ...r, attachmentId: payload.attachmentId }
                    : r,
                ),
              );
            }}
          />
          <div className="d-flex align-items-center pe-2">
            {(row.attachmentId && (
              <img
                src="assets/img/newIcons/attached-file.png"
                className="mt-1 attachmentIcon"
                alt="attachments"
                onClick={() => handleViewFile(row.attachmentId)}
              />
            )) ||
              "--"}
          </div>
        </div>
      ),
      width: "350px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let POLineItemInitialData = [
    {
      local_id: 1,
      purchasingReqDocumentItemNr: 1,
      itemTextData: [],
      prStatusItem: "In Release",
      currency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  // Inital Create Service PO
  let ServicePOLineItemInitialCol = [
    {
      name: "Sl",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "60px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Service",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.services, "SER")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          error={lineItemErrors[row.local_id]?.purchaseQuantity}
        />
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.orderUnitOfMeasure}
        />
      ),
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          error={lineItemErrors[row.local_id]?.orderPriceUnit}
        />
      ),
      width: "120px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "120px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "110px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "135px",
    },
    {
      name: "Tax % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.deliveryDate}
        />
      ),
      width: "180px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.plant}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  // eslint-disable-next-line
  let ServicePOLineItemInitialData = [
    {
      local_id: 1,
      purchasingReqDocumentItemNr: 1,
      itemTextData: [],
      prStatusItem: "In Release",
      curency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  // Inital Create Schedule PO
  let SchedulePOLineItemInitialCol = [
    {
      name: "Sl",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "60px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Schedule",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.schedule, "SE")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          error={lineItemErrors[row.local_id]?.purchaseQuantity}
        />
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.orderUnitOfMeasure}
        />
      ),
      width: "120px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          error={lineItemErrors[row.local_id]?.orderPriceUnit}
        />
      ),
      width: "120px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "120px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "110px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Tax % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.deliveryDate}
        />
      ),
      width: "180px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          error={lineItemErrors[row.local_id]?.plant}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  // eslint-disable-next-line
  let SchedulePOLineItemInitialData = [
    {
      local_id: 1,
      purchasingReqDocumentItemNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      currency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  // eslint-disable-next-line
  // const [loading, setLoading] = useState(false);
  const [getLineItemHeaderTextModal, setLineItemHeaderTextModal] =
    useState(false);
  const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);
  const [getDataToHeaderText, setDataToHeaderText] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getTaxAmountValue, setTaxAmountValue] = useState(0);
  const [getItemAmountValue, setItemAmountValue] = useState(0);
  // Budget check by Company + Cost Center + Category (budgetCreationDoc)
  const [budgetAllocated, setBudgetAllocated] = useState(0);
  const [budgetAvailable, setBudgetAvailable] = useState(0);
  const budgetToastShownRef = useRef(false);
  const [getPurchaseType, setPurchaseType] = useState(0);
  const [getPurchaseCategory, setPurchaseCategory] = useState(0);
  // eslint-disable-next-line
  const [getpurchaseGroup, setpurchaseGroup] = useState(0);

  //Services
  const [getServicesLineItemModal, setServicesLineItemModal] = useState(false);
  const [getServicesLineItemIndex, setServicesLineItemIndex] = useState(0);
  const [getServicesLineItemText, setServicesLineItemText] = useState([]);
  const [getServiceTitle, setServiceTitle] = useState("");

  //Schedule
  // const [getScheduleLineItemModal, setScheduleLineItemModal] = useState(false);
  // const [getScheduleLineItemIndex, setScheduleLineItemIndex] = useState(0);
  // const [getScheduleLineItemText, setScheduleLineItemText] = useState([]);

  // Header Text
  const handleHeaderTextLineItemData = (data) => {
    setPOLineItemsData((prevUsers) =>
      prevUsers.map((item) =>
        item.local_id === getHeaderTextIndex
          ? { ...item, itemTextData: data }
          : item,
      ),
    );
  };

  //Service PO and Schedule PO
  const handleServicePOLineItemData = (data) => {
    if (formInputs.purchaseTypeCode === "SER") {
      let totalServiceQty = 0;
      let totalGrossValue = 0;
      let orderUnitOfMeasure = 0;

      data.map((item) => {
        totalServiceQty += Number(item.serviceQuantity);
        totalGrossValue += Number(item.grossValue);
        orderUnitOfMeasure = item.orderUnitOfMeasure;
        return "";
      });

      setPOLineItemsData((prevUsers) =>
        prevUsers.map((item, index) => {
          return item.purchasingReqDocumentItemNr === getServicesLineItemIndex
            ? {
                ...item,
                services: data,
                purchaseQuantity: totalServiceQty,
                orderPriceUnit: totalGrossValue,
                orderUnitOfMeasure: orderUnitOfMeasure,
              }
            : item;
        }),
      );
    } else {
      let totalScheduleQty = 0;

      data.map((item) => {
        totalScheduleQty += Number(item.scheduleQuantity);
        return "";
      });

      setPOLineItemsData((prevUsers) =>
        prevUsers.map((item) => {
          return item.purchasingReqDocumentItemNr === getServicesLineItemIndex
            ? {
                ...item,
                schedule: data,
                purchaseQuantity: totalScheduleQty,
              }
            : item;
        }),
      );
    }
  };

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getPOLineItemsData, setPOLineItemsData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getPOLineItemsCol, setPOLineItemsCol] = useState(POLineItemInitialCol);

  const [getPRDocTypes, setPRDocTypes] = useState([]);
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // Companies created in Company Creation - used by Company Code & Purchase Organization
  const [getCompanyListOptions, setCompanyListOptions] = useState([]);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  // const [getLdperdaypercentage, setLdperdaypercentage] = useState([]);
  // const [getLdApplicability, setLdApplicability] = useState([]);
  // const [getdownPaymentCategory, setdownPaymentCategory] = useState([]);
  // const [getmodeOfTransport, setmodeOfTransport] = useState([]);
  // const [getretention, setretention] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    // SuccessRegisterModal listens for Esc even while hidden - ignore Esc while filling the form
    if (!getShowSuccessModal) return;
    setShowSuccessModal(false);
    navigate(Constants.SOURCING_PURCHASE_REQUISITION_LIST, { replace: true });
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };

  /* Create PO Line Item Header Text Modal Function */
  const showLineItemHeaderText = (index, data) => {
    setLineItemHeaderTextModal(true);
    setHeaderTextIndex(index);
    setDataToHeaderText(data);
  };
  const hideLineItemHeaderText = () => {
    setLineItemHeaderTextModal(false);
  };

  /* Create Header Text Modal Function */
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
    setDataToHeaderText();
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Text",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
    // {
    //   name: "Delete",
    //   cell: (row, index) => (
    //     <>
    //       <span>
    //         <i
    //           onClick={() => handleDelete(index)}
    //           className="bi bi-trash text-danger fs-3"
    //         ></i>
    //       </span>
    //     </>
    //   ),
    //   width: "10rem",
    // },
  ];

  /* Create Services PO Line Item Modal Function */
  const showServicesLineItem = (index, data, type) => {
    setServicesLineItemModal(true);
    setServicesLineItemIndex(index);
    setServicesLineItemText(data);
    setServiceTitle(type === "SER" ? "Services List" : "Schedule List");
  };
  const hideServicesLineItem = () => {
    setServicesLineItemModal(false);
  };

  //material selection
  const [modalShow, setModalShow] = useState(false);

  /* Modal Function */
  const addProductDetails = () => {
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const reIndexRows = (rows) => {
    return rows.map((row, index) => ({
      ...row,
      local_id: index + 1,
      purchasingReqDocumentItemNr: String(index + 1).padStart(3, "0"),
    }));
  };

  // Ref to prevent duplicate concurrent network calls
  const isFetchingVendorsList = useRef(false);

  const fetchVendorList = useCallback(async () => {
    if (isFetchingVendorsList.current || vendorList.length > 0) return; // Guard
    isFetchingVendorsList.current = true;
    try {
      let obj = {
        timeZone: "Asia/Calcutta",
      };
      const response = await ItemService.getSupplierDatail(obj);
      if (response?.status === 200) {
        setVendorList(response?.data || []);
      } else {
        setVendorList([]);
      }
    } catch (error) {
      console.error("Error fetching vendor list:", error);
    } finally {
      isFetchingVendorsList.current = false;
    }
  }, [vendorList.length]);

  const handleGetSelectedMaterial = (selectedData) => {
    if (!Array.isArray(selectedData) || selectedData.length === 0) return;
    if (vendorList.length === 0) {
      fetchVendorList();
    }

    const mappedData = selectedData.map((item) => ({
      materialCode: item.materialCode || "",
      materialDescription: item.materialDescription || "",
      materialGroup: item.materialGroup || "",
      incoTerms: item.incoTerms || "",
      incoTermsCode: item.incoTermsCode || "",
      purchaseQuantity: 0,
      orderUnitOfMeasure:
        item.orderUnitOfMeasure || item.uOM || item.unit || "",
      orderPriceUnit: item.orderPriceUnit || item.unitPrice || 0,
      deliveryDate: item.deliveryDate || getCurrentDate("default"),
      netValue: (item.orderPriceUnit || item.unitPrice || 0) * 0,
      itemCurrency: item.itemCurrency || formInputs.currencyCode || "INR",
      currencyCode: item.currencyCode || formInputs.currencyCode || "INR",
      plant: item.plant || "",
      storageLocn: item.storageLocn || "",
      taxCode: 0,
      taxAmount: 0,
      itemTextData: [],
      prStatusItem: "In Release",
      subCategory: item.subCategory || "",
      specification: item.specification || "",
      lastSupplierName: item.lastPurchase?.vendorName || "-",
      lastPurchaseRate: item.lastPurchase?.price || "-",
      lastPurchaseCurrency: item.lastPurchase?.currency || "-",
      lastPurchasePONumber: item.lastPurchase?.poNumber || "-",
      lastPurchasePOApprovedAt: item.lastPurchase?.approvedAt || "-",
      lastPurchaseUpdatedAt: item.lastPurchase?.updatedAt || "-",
    }));

    setPOLineItemsData((prevRows) => {
      const newRows = [...prevRows, ...mappedData];
      return reIndexRows(newRows);
    });
  };

  // const onInputChange = ({ target: { name, value } }) => {
  //   setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  //   // console.log("onInputChange => formInputs", formInputs);
  // };
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setValidation((prev) => (prev[name] ? { ...prev, [name]: "" } : prev));
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">> Dropdown data > ", getDropdownData);

    // ComboboxField reports its starting value (with no `name`) when it first renders.
    // Ignore that, otherwise a resumed draft's value (e.g. Delivery Address) is overwritten
    // with undefined. A real user selection always has a `name`.
    if (!getDropdownData?.name) return;

    // Only the Purchase Type dropdown may switch the line-item layout. Other dropdowns
    // (e.g. Document type) could have a code like "MAT" and must not wipe line items.
    const isPurchaseType = getDropdownData?.textField === "purchaseType";

    if (isPurchaseType && getDropdownData?.code === "SA") {
      // Schedule Agreement
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
      setPOLineItemsCol(SchedulePOLineItemInitialCol);
      setPOLineItemsData([]);
    } else if (isPurchaseType && getDropdownData?.code === "SER") {
      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
      setPOLineItemsCol(ServicePOLineItemInitialCol);
      setPOLineItemsData([]);
    } else if (isPurchaseType && getDropdownData?.code === "MAT") {
      // Material
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
      setPOLineItemsCol(POLineItemInitialCol);
      setPOLineItemsData([]);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
    }

    if (getDropdownData?.textField) {
      setValidation((prev) => ({ ...prev, [getDropdownData.textField]: "" }));
    }
    // Purchase type change wipes the line items, so wipe their errors too
    if (getDropdownData?.textField === "purchaseType") {
      setLineItemErrors({});
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // useEffect(() => {
  //   setPOLineItemsCol(POLineItemInitialCol);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [vendorList]);

  // Only fetch suppliers if line items exist and vendorList is not yet loaded
  useEffect(() => {
    if (getPOLineItemsData?.length > 0 && vendorList.length === 0) {
      fetchVendorList();
    }
  }, [getPOLineItemsData, vendorList.length, fetchVendorList]);

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;

    setLineItemErrors((prev) =>
      prev[local_id]?.[name]
        ? { ...prev, [local_id]: { ...prev[local_id], [name]: "" } }
        : prev,
    );

    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  netValue:
                    name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value,
                  taxAmount:
                    (Number(row.taxCode) / 100) *
                    (name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value),
                }
              : row;
          }),
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  taxAmount:
                    name === "taxCode"
                      ? (Number(value) / 100) *
                        (Number(row.purchaseQuantity || 0) *
                          Number(row.orderPriceUnit || 0))
                      : 0,
                }
              : row,
          ),
        );
      }
    } else {
      setPOLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row,
        ),
      );
    }
    // getTotalCount()
  };

  // Get Total for SubTotal Pricing Schedule
  useEffect(() => {
    // console.log(">> getPOLineItemsData", getPOLineItemsData);

    const getItemTotal = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.netValue || 0),
      0,
    );
    const taxTotalAmount = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.taxAmount || 0),
      0,
    );

    setTaxAmountValue(taxTotalAmount);
    setItemAmountValue(getItemTotal);

    setSubTotalValue(getItemTotal + taxTotalAmount);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPOLineItemsData]);

  /* ---------------------------- Budget check by Company + Cost Center + Purchase Category (frontend only) --------------------------------*/
  const loadBudgetForMatch = async (category, company, costCenter) => {
    try {
      const norm = (v) => (v || "").trim().toLowerCase();
      const prCompany = norm(company);
      const prCost = norm(costCenter);
      const prCat = norm(category);

      await ItemService.getBudgetList({
        page: 1,
        per_page: 500,
        searchTerm: category,
      }).then((item) => {
        if (item?.status === 200 && item?.data?.length) {
          // Budgets are created per individual Company + Cost Center + Category
          const matched = item.data.filter((b) => {
            const bCat = norm(b.category);
            const bCost = norm(b.costCenter);
            const bComp = norm(b.company);
            if (prCat && bCat !== prCat) return false;
            if (prCost && bCost !== prCost) return false;
            if (prCompany) {
              if (!bComp) return false;
              if (
                !(
                  prCompany === bComp ||
                  prCompany.includes(bComp) ||
                  bComp.includes(prCompany)
                )
              )
                return false;
            }
            return true;
          });
          const allocated = matched.reduce(
            (acc, b) => acc + (Number(b.budgetAmount) || 0),
            0,
          );
          setBudgetAllocated(allocated);
          setBudgetAvailable(allocated);
        } else {
          setBudgetAllocated(0);
          setBudgetAvailable(0);
        }
      });
    } catch (error) {
      console.log("loadBudgetForMatch Failed:", error);
      setBudgetAllocated(0);
      setBudgetAvailable(0);
    }
  };

  useEffect(() => {
    const category = formInputs?.purchaseCategory;
    const company = formInputs?.companyCode;
    const costCenter = formInputs?.costCenter;
    if (!category || !company || !costCenter) {
      setBudgetAllocated(0);
      setBudgetAvailable(0);
      budgetToastShownRef.current = false;
      return;
    }
    loadBudgetForMatch(category, company, costCenter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formInputs?.purchaseCategory, formInputs?.companyCode, formInputs?.costCenter]);

  useEffect(() => {
    const category = formInputs?.purchaseCategory;
    if (!category || !budgetAvailable) return;
    if (subTotalValue > budgetAvailable) {
      if (formInputs.budgetAvailability !== "No") {
        setFormInputs((prev) => ({ ...prev, budgetAvailability: "No" }));
      }
      if (!budgetToastShownRef.current) {
        budgetToastShownRef.current = true;
        toast.error(
          "PR total exceeds available budget for this Company, Cost Center & Category - Business Justification required!",
          { duration: 4000, position: "top-right" },
        );
      }
    } else {
      budgetToastShownRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subTotalValue, budgetAvailable, formInputs?.purchaseCategory]);


  // Load Master Data in Parallel
  const getMasterDataFunc = async () => {
    try {
      const [
        purchaseOrgRes,
        companyCodeRes,
        incoTermsRes,
        currencyRes,
        paymentTermRes,
        purchaseTypeRes,
        purchaseCategoryRes,
        prDocTypeRes,
        companyListRes,
      ] = await Promise.allSettled([
        ItemService.getMasterData({ codeType: "purchaseOrganisation" }),
        ItemService.getMasterData({ codeType: "companyCode" }),
        ItemService.getMasterData({ codeType: "INCOTerms" }),
        ItemService.getMasterData({ codeType: "currency" }),
        ItemService.getMasterData({ codeType: "paymentTerm" }),
        ItemService.getMasterData({ codeType: "PrPurchaseType" }),
        ItemService.getMasterData({ codeType: "PurchaseCategory" }),
        ItemService.getMasterData({ codeType: "PurchaseDocType" }),
        ItemService.getCompanyList({ page: 1, per_page: 500 }),
      ]);

      if (
        purchaseOrgRes.status === "fulfilled" &&
        purchaseOrgRes.value?.status === 200
      )
        setPurchaseOrg(purchaseOrgRes.value.data);

      if (
        companyCodeRes.status === "fulfilled" &&
        companyCodeRes.value?.status === 200
      )
        setCompanyCode(companyCodeRes.value.data);

      if (
        incoTermsRes.status === "fulfilled" &&
        incoTermsRes.value?.status === 200
      )
        setINCOTerms(incoTermsRes.value.data);

      if (
        currencyRes.status === "fulfilled" &&
        currencyRes.value?.status === 200
      )
        setcurrency(currencyRes.value.data);

      if (
        paymentTermRes.status === "fulfilled" &&
        paymentTermRes.value?.status === 200
      )
        setpaymentTerm(paymentTermRes.value.data);

      if (
        purchaseTypeRes.status === "fulfilled" &&
        purchaseTypeRes.value?.status === 200
      )
        setPurchaseType(purchaseTypeRes.value.data);

      if (
        purchaseCategoryRes.status === "fulfilled" &&
        purchaseCategoryRes.value?.status === 200
      )
        setPurchaseCategory(purchaseCategoryRes.value.data);

      if (
        prDocTypeRes.status === "fulfilled" &&
        prDocTypeRes.value?.status === 200
      )
        setPRDocTypes(prDocTypeRes.value.data);

      // Companies created in Company Creation page - show code & name in dropdowns
      if (
        companyListRes.status === "fulfilled" &&
        companyListRes.value?.status === 200 &&
        companyListRes.value?.data?.length
      ) {
        setCompanyListOptions(
          companyListRes.value.data.map((c, i) => {
            const code = c.companyCode || "";
            const name = c.companyName || "";
            return {
              id: c._id || i + 1,
              name:
                code && name
                  ? `${code} - ${name}`
                  : name || code || "",
              code: code,
              description: name,
            };
          }),
        );
      }
    } catch (error) {
      // Safety net — Promise.allSettled itself never rejects
      console.error("Unexpected error in getMasterDataFunc:", error);
    } finally {
    }
  };

  const isSubmittingRef = useRef(false);

  // SAVE
  const handleSave = async () => {
    if (isSubmittingRef.current) return; // already submitting / already created

    const requiredFields = [];
    const errors = {};

    // Header – `key` must equal the field's `name` prop, so its red border
    // clears automatically when the user selects / types a value
    const REQUIRED_HEADER_FIELDS = [
      {
        key: "purchasingReqDocumentType",
        msg: "*Please Select the Document Type",
      },
      { key: "companyCode", msg: "*Please Select the Company Code" },
      { key: "purchasingOrg", msg: "*Please Select the Purchase Organization" },
      { key: "purchasingGroup", msg: "*Please Select the Purchase Group" },
      { key: "purchaseType", msg: "*Please Select the Purchase Type" },
      { key: "paymentTerms", msg: "*Please Select the Payment Terms" },
      { key: "costCenter", msg: "*Please Select the Cost Center" },
      { key: "deliveryAddress", msg: "*Please Select the Delivery Address" },
    ];
    REQUIRED_HEADER_FIELDS.forEach(({ key, msg }) => {
      if (!validateRequired(formInputs[key])) {
        requiredFields.push(msg);
        errors[key] = REQUIRED_MSG;
      }
    });

    // INCOTerms is optional, but once chosen it needs a location
    if (
      validateRequired(formInputs.incoTerms) &&
      !validateRequired(formInputs.incoTermsLocation)
    ) {
      requiredFields.push("*Please enter the INCOTerms Location");
      errors.incoTermsLocation = REQUIRED_MSG;
    }

    // Justification needed when budget is NOT available (if business agrees)
    if (
      formInputs.budgetAvailability !== "Yes" &&
      !validateRequired(formInputs.businessJustification)
    ) {
      requiredFields.push(
        "*Please enter the Business Justification (budget not available)",
      );
      errors.businessJustification = REQUIRED_MSG;
    }

    // Line items
    const itemErrors = {};
    if (getPOLineItemsData.length === 0) {
      requiredFields.push("*Atleast one line item should be added.");
    }
    getPOLineItemsData.forEach((item) => {
      const rowErr = {};
      if (!item.purchaseQuantity || Number(item.purchaseQuantity) <= 0) {
        rowErr.purchaseQuantity = "Must be > 0";
      }
      if (!validateRequired(item.orderUnitOfMeasure)) {
        rowErr.orderUnitOfMeasure = "Required";
      }
      if (!item.orderPriceUnit || Number(item.orderPriceUnit) <= 0) {
        rowErr.orderPriceUnit = "Must be > 0";
      }
      if (!validateRequired(item.deliveryDate)) {
        rowErr.deliveryDate = "Required";
      }
      if (!validateRequired(item.plant)) {
        rowErr.plant = "Required";
      }
      if (Object.keys(rowErr).length > 0) itemErrors[item.local_id] = rowErr;
    });
    if (Object.keys(itemErrors).length > 0) {
      requiredFields.push(
        `*Please fill Quantity (> 0), UOM, Unit Price (> 0), Delivery Date and Plant for line item(s): ${Object.keys(itemErrors).join(", ")}`,
      );
    }

    setValidation(errors);
    setLineItemErrors(itemErrors);

    // Show ALL missing fields at once (not one by one)
    if (requiredFields.length > 0) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    // // let lineItem = []
    // formInputs.items = getPOLineItemsData;
    // // formInputs.vendorCode = getVendorDropdown.id;
    // // formInputs.vendorName = getVendorDropdown.firstName;
    // formInputs.headerTextData = getHeaderTextSelectedData;
    // formInputs.purchasingReqDocumentValue = subTotalValue;
    // formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
    // formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;
    // formInputs.currencyCode = getCurrencyDropdown.code;
    // formInputs.currency = getCurrencyDropdown.name;

    // // Append draft info
    // formInputs.draftData = {
    //   draftUserId: userData?.data?.userId,
    //   draftDocumentNumber: draftData?.documentNumber,
    //   draftType: draftData?.draftType,
    // };

    // // console.log(">> handleSave", formInputs);

    // // let obj = {
    // //   data: formInputs,
    // // };

    // Build the PR payload without mutating state
    const payload = {
      ...formInputs,
      items: getPOLineItemsData,
      headerTextData: getHeaderTextSelectedData,
      purchasingReqDocumentValue: subTotalValue,
      purchasingDocumentTaxTotalValue: getTaxAmountValue,
      purchasingDocumentItemTotalValue: getItemAmountValue,
      currencyCode: getCurrencyDropdown.code,
      currency: getCurrencyDropdown.name,
      draftData: {
        draftUserId: userData?.data?.userId,
        draftDocumentNumber: draftDataRef.current?.documentNumber,
        draftType: draftDataRef.current?.draftType,
      },
    };

    let obj = {
      data: payload,
    };

    isSubmittingRef.current = true;
    setDisabled(true);
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let created = false;
    try {
      const item = await ItemService.addPR(obj);
      if (item?.status === 200) {
        created = true;
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("addPR failed:", error);
      toast.error("Please try again !!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
      // Only allow another attempt if this one failed.
      // After success the button stays disabled, so Esc + click can't create a duplicate PR.
      if (!created) {
        isSubmittingRef.current = false;
        setDisabled(false);
      }
    }
  };
  // eslint-disable-next-line
  const addPOItemRow = () => {
    setPOLineItemsData((prevRows) => {
      POLineItemInitialData[0].local_id = prevRows.length + 1;
      POLineItemInitialData[0].purchasingReqDocumentItemNr =
        prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...POLineItemInitialData];
    });
  };

  const removePOItemRow = (local_id) => {
    setLineItemErrors({});
    setPOLineItemsData((prevPrograms) => {
      const filtered = prevPrograms.filter(
        (program) => program.local_id !== local_id,
      );
      return reIndexRows(filtered);
    });
  };

  // Refs
  const previousFormInputsRef = useRef(null);
  const isFirstAutoSave = useRef(true);
  const draftDataRef = useRef(null); // to avoid stale closure in auto-save

  // Helper: get changed fields
  const getChangedFields = (oldData, newData) => {
    if (!oldData) return {};
    const changes = {};
    Object.keys(newData).forEach((key) => {
      if (!isEqual(oldData[key], newData[key])) {
        changes[key] = newData[key];
      }
    });
    return changes;
  };

  // Helper: map draft API response to form state
  // const mapDraftToFormInputs = (draft) => {
  //   const empty = createEmptyFormInputs();
  //   return {
  //     ...empty,
  //     ...draft,
  //     // ensure nested arrays are overwritten
  //     headerTextData: draft.headerTextData || [],
  //     items: draft.items || [],
  //     incoTerms: draft.incoTerms || "",
  //     incoTermsCode: draft.incoTermsCode || "",
  //     // Doc type must come from the draft itself. Redux may hold the type
  //     // picked for a different PR earlier in this session.
  //     purchasingReqDocumentType: draft.purchasingReqDocumentType || "",
  //     purchasingReqDocumentCode: draft.purchasingReqDocumentCode || "",
  //     // any other nested fields
  //   };
  // };

  // Helper: map draft API response to form state
  const mapDraftToFormInputs = (draft) => {
    // Draft metadata stays in draftData, not in the form. Otherwise it is sent to
    // addPR (which upserts on _id) and compared/saved again by auto-save.
    const {
      _id,
      documentNumber,
      draftType,
      draftName,
      userId,
      createdAt,
      updatedAt,
      renamedAt,
      timeZone,
      ...formFields
    } = draft;
    const empty = createEmptyFormInputs();
    return {
      ...empty,
      ...formFields,
      // ensure nested arrays are overwritten
      headerTextData: formFields.headerTextData || [],
      items: formFields.items || [],
      incoTerms: formFields.incoTerms || "",
      incoTermsCode: formFields.incoTermsCode || "",
      // Doc type must come from the draft itself. Redux may hold the type
      // picked for a different PR earlier in this session.
      purchasingReqDocumentType: formFields.purchasingReqDocumentType || "",
      purchasingReqDocumentCode: formFields.purchasingReqDocumentCode || "",
    };
  };

  useEffect(() => {
    const loadDrafts = async () => {
      setLoadingDrafts(true);

      await getMasterDataFunc();

      if (draftIdParam) {
        try {
          await handleSelectDraft(draftIdParam);
        } catch (error) {
          console.error("loadDraftById error", error);
          toast.error("Error loading draft.");
          navigate(Constants.SOURCING_PURCHASE_REQUISITION_LIST);
        } finally {
          setLoadingDrafts(false);
        }
        return;
      }

      // if (newDraftParam || !draftIdParam) {
      //   setLoadingDrafts(true);
      //   await createNewDraftAndProceed();
      //   setLoadingDrafts(false);
      //   return;
      // }
      if (newDraftParam || !draftIdParam) {
        try {
          await createNewDraftAndProceed();
        } catch (error) {
          console.error("createNewDraftAndProceed error", error);
        } finally {
          setLoadingDrafts(false);
        }
        return;
      }
    };

    if (userData?.data?.userId) {
      loadDrafts();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.data?.userId, newDraftParam]);

  // Helper to create new draft and set form
  const createNewDraftAndProceed = async () => {
    try {
      const createRes = await ItemService.createDraft(
        userData?.data?.userId,
        "MANUAL_PR",
      );
      if (createRes?.success && createRes?.data) {
        const emptyData = createEmptyFormInputs();
        // Populate with draft metadata
        const draft = createRes.data;
        setDraftData(draft);
        draftDataRef.current = draft;
        setFormInputs(emptyData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
        setHeaderTextSelectedData(emptyData.headerTextData || []);
        setPOLineItemsData(emptyData.items || []);

        // The create-draft API only stores userId + draftType, and auto-save only sends
        // changed fields, so save the document type chosen in the PR list popup now.
        // Otherwise "Drafts → Continue Selected" can't know which type this PR was.
        if (emptyData.purchasingReqDocumentType) {
          await ItemService.updateDraft(
            draft.documentNumber,
            userData?.data?.userId,
            "MANUAL_PR",
            {
              purchasingReqDocumentType: emptyData.purchasingReqDocumentType,
              purchasingReqDocumentCode: emptyData.purchasingReqDocumentCode,
            },
          );
        }
      } else {
        // If creation fails, use empty form without draft
        const emptyData = createEmptyFormInputs();
        setFormInputs(emptyData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
      }
    } catch (error) {
      console.error("createNewDraftAndProceed error", error);
      const emptyData = createEmptyFormInputs();
      setFormInputs(emptyData);
      previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
    }
  };

  // Handlers for modal
  const handleSelectDraft = async (draftNumber) => {
    try {
      const res = await ItemService.getDraftById(
        draftNumber,
        "MANUAL_PR",
        userData?.data?.userId,
      );
      if (res?.success && res?.data) {
        const draft = res.data;
        const mappedData = mapDraftToFormInputs(draft);
        setDraftData(draft);
        draftDataRef.current = draft;
        setFormInputs(mappedData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(mappedData));
        setHeaderTextSelectedData(mappedData.headerTextData || []);
        setPOLineItemsData(mappedData.items || []);
      } else {
        toast.error("Failed to load draft.");
      }
    } catch (error) {
      console.error("handleSelectDraft error", error);
      toast.error("Error loading draft.");
    }
  };

  // Keep draftData in a ref to avoid dependency issues
  useEffect(() => {
    draftDataRef.current = draftData;
  }, [draftData]);

  useEffect(() => {
    // Skip first mount (initial render)
    if (isFirstAutoSave.current) {
      isFirstAutoSave.current = false;
      previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
      return;
    }

    // // Don't run if draft is still loading or draftData is missing
    // if (
    //   loadingDrafts ||
    //   !draftDataRef.current ||
    //   !previousFormInputsRef.current
    // ) {
    //   return;
    // }

    // // Check if anything changed
    // const hasDataChanged =
    //   JSON.stringify(previousFormInputsRef.current) !==
    //   JSON.stringify(formInputs);
    // if (!hasDataChanged) {
    //   return;
    // }

    // const timer = setTimeout(async () => {
    //   try {
    //     await updateDraft();
    //     // Update reference after successful save
    //     previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
    //   } catch (error) {
    //     console.error("Auto-save draft failed:", error);
    //   }
    // }, 2000);

    // return () => clearTimeout(timer);

    // Don't run if draft is still loading, missing, or the PR is being/has been created
    if (
      loadingDrafts ||
      isSubmittingRef.current ||
      !draftDataRef.current ||
      !previousFormInputsRef.current
    ) {
      return;
    }

    // Check if anything changed
    const hasDataChanged =
      JSON.stringify(previousFormInputsRef.current) !==
      JSON.stringify(formInputs);
    if (!hasDataChanged) {
      return;
    }

    // updateDraft moves the baseline only when the save succeeds
    const timer = setTimeout(() => {
      updateDraft();
    }, 2000);

    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formInputs, loadingDrafts]);

  // // When document texts change, update formInputs
  // const updateDraft = async () => {
  //   if (!previousFormInputsRef.current || !draftDataRef.current) {
  //     console.warn("Skipping draft update: no baseline");
  //     return;
  //   }

  //   //  Calculate current progress
  //   const newProgress = calculateDraftProgress(formInputs);

  //   const changedData = getChangedFields(
  //     previousFormInputsRef.current,
  //     formInputs,
  //   );
  //   // if (Object.keys(changedData).length === 0) return;

  //   changedData.completionPercentage = newProgress;

  //   // If nothing else changed except progress, still update
  //   if (
  //     Object.keys(changedData).length === 1 &&
  //     changedData.completionPercentage !== undefined
  //   ) {
  //     // Only progress changed – we can still save it
  //   } else if (Object.keys(changedData).length === 0) {
  //     return; // nothing to update
  //   }

  //   try {
  //     const response = await ItemService.updateDraft(
  //       draftDataRef.current?.documentNumber,
  //       userData?.data?.userId,
  //       "MANUAL_PR",
  //       changedData,
  //     );
  //     if (response.status === 200) {
  //       previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
  //       // Optionally update draftDataRef with new timestamps
  //     }
  //   } catch (error) {
  //     console.error("Update draft failed:", error);
  //   }
  // };

  // Auto-save: send only the fields changed since the last successful save
  const updateDraft = async () => {
    const draft = draftDataRef.current;
    // isSubmittingRef: the PR is being/has been created and the backend deletes this draft
    if (!draft || !previousFormInputsRef.current || isSubmittingRef.current) {
      return;
    }

    const snapshot = formInputs;
    const changedData = getChangedFields(
      previousFormInputsRef.current,
      snapshot,
    );
    changedData.completionPercentage = calculateDraftProgress(snapshot);

    const response = await ItemService.updateDraft(
      draft.documentNumber,
      userData?.data?.userId,
      "MANUAL_PR",
      changedData,
    );

    // Draft was replaced or detached while this request was in flight
    if (draftDataRef.current !== draft) return;

    if (response?.status === 200) {
      // move the baseline only when the save really succeeded
      previousFormInputsRef.current = JSON.parse(JSON.stringify(snapshot));
      return;
    }

    if (response?.status === 404) {
      // Deleted elsewhere (other tab / Drafts popup) - stop auto-saving to it
      draftDataRef.current = null;
      setDraftData(null);
      toast.error(
        "This draft no longer exists. Your changes are not being auto-saved.",
      );
      return;
    }

    console.error("Update draft failed:", response?.message);
  };

  useEffect(() => {
    setFormInputs((prev) => ({
      ...prev,
      headerTextData: getHeaderTextSelectedData,
    }));
  }, [getHeaderTextSelectedData]);

  // When line items change, update formInputs
  useEffect(() => {
    setFormInputs((prev) => ({ ...prev, items: getPOLineItemsData }));
  }, [getPOLineItemsData]);

  // if (loadingDrafts) {
  //   return (
  //     <main className="dashboard main" id="main">
  //       <Layout />
  //       {/* <div className="text-center mt-5">Loading draft...</div> */}
  //       <Loader isLoading={getLoader} className={"text-center"} />
  //     </main>
  //   );
  // }

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Purchase Requisition</h2>
            <p className="subText">Fill Purchase Requisition Details</p>
            <hr />

            <Loader isLoading={loadingDrafts} className={"text-center"} />

            {!loadingDrafts && (
              <>
                {/*Document Header Details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">HD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Header Details</span>
                          <span className="subHeaderTitle">
                            Document Description and Details{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchasingReqDocumentType"
                              label="Document type"
                              placeholder="Select Document Type"
                              data={getPRDocTypes}
                              iconClassName="dropdownIcon"
                              name="purchasingReqDocumentType"
                              code="purchasingReqDocumentCode"
                              setValue={
                                formInputs?.purchasingReqDocumentType || []
                              }
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.purchasingReqDocumentType}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="prStatusHeader"
                              className="inputBox"
                              label="Status"
                              name="prStatusHeader"
                              placeholder=""
                              value={formInputs.prStatusHeader}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="version"
                              className="inputBox"
                              label="Version"
                              name="version"
                              placeholder=""
                              value={formInputs.version}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Company Code"
                              extraLabel="SAP Company Code"
                              placeholder=""
                              data={
                                getCompanyListOptions.length
                                  ? getCompanyListOptions
                                  : getCompanyCode
                              }
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              setValue={formInputs?.companyCode || []}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.companyCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Business Unit"
                              name="businessUnit"
                              code="businessUnitCode"
                              placeholder="Select Business Unit"
                              data={getBusinessUnitOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.businessUnit || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Organization"
                              extraLabel="SAP Purchase organization"
                              placeholder=""
                              data={
                                getCompanyListOptions.length
                                  ? getCompanyListOptions
                                  : getPurchaseOrg
                              }
                              id="purchasingOrg"
                              iconClassName="dropdownIcon"
                              name="purchasingOrg"
                              code="purchasingOrgCode"
                              setValue={formInputs?.purchasingOrg || []}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.purchasingOrg}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Group"
                              name="purchasingGroup"
                              // data={getpurchaseGroup}
                              data={getpurchaseGroup1}
                              id="purchasingGroup"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.purchasingGroup || []}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.purchasingGroup}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseType"
                              label="Purchase Type"
                              placeholder=""
                              data={getPurchaseType}
                              iconClassName="dropdownIcon"
                              name="purchaseType"
                              code="purchaseTypeCode"
                              setValue={formInputs?.purchaseType || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              required={true}
                              error={validation.purchaseType}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseCategory"
                              label="Purchase Category"
                              placeholder=""
                              data={getPurchaseCategory}
                              iconClassName="dropdownIcon"
                              name="purchaseCategory"
                              code="purchaseCategoryCode"
                              setValue={formInputs?.purchaseCategory || []}
                              getvalue={setDropdownData}
                              disabled={false}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingReqDocumentDate"
                              className="inputBox"
                              label="Document Date"
                              name="purchasingReqDocumentDate"
                              placeholder=""
                              type="date"
                              value={formInputs.purchasingReqDocumentDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Payment Terms"
                              extraLabel=""
                              placeholder=""
                              data={getpaymentTerm}
                              id="paymentTerms"
                              iconClassName="dropdownIcon"
                              name="paymentTerms"
                              code="paymentTermsCode"
                              setValue={formInputs?.paymentTerms || []}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.paymentTerms}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="INCOTerms"
                              extraLabel="INCOTerms Code"
                              placeholder=""
                              data={getINCOTerms}
                              id="incoTerms"
                              iconClassName="dropdownIcon"
                              name="incoTerms"
                              code="incoTermsCode"
                              setValue={formInputs?.incoTerms || ""}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="incoTermsLocation"
                              className="inputBox"
                              label="INCOTerms Location"
                              name="incoTermsLocation"
                              placeholder=""
                              value={formInputs.incoTermsLocation}
                              onChange={onInputChange}
                              required={!!formInputs.incoTerms}
                              error={validation.incoTermsLocation}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Currency"
                              placeholder=""
                              data={getcurrency}
                              id="currency"
                              iconClassName="dropdownIcon"
                              name="currency"
                              code="currencyCode"
                              setValue={
                                getCurrencyDropdown?.name || {
                                  code: "INR",
                                  name: "INR-Rupee",
                                }
                              }
                              getvalue={setCurrencyDropdown}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Cost Center"
                              name="costCenter"
                              code="costCenterCode"
                              placeholder="Select Cost Center"
                              data={getCostCenterOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.costCenter || []}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.costCenter}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="itemTotalAmount"
                              className="inputBox"
                              label="Item Total Amount"
                              name="purchasingDocumentItemTotalValue"
                              placeholder=""
                              value={getItemAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentTaxTotalValue"
                              className="inputBox"
                              label="Total Tax Amount"
                              name="purchasingDocumentTaxTotalValue"
                              placeholder=""
                              value={getTaxAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingReqDocumentValue"
                              className="inputBox"
                              label="Purchase Net Value"
                              name="purchasingReqDocumentValue"
                              placeholder=""
                              value={subTotalValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>

                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Exchange Rate"
                              name="firstName"
                              placeholder=""
                              // value={""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Priority"
                              name="priority"
                              code="priorityCode"
                              placeholder="Select Priority"
                              data={getPriorityOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.priority || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="GL Account"
                              name="glAccount"
                              code="glAccountCode"
                              placeholder="Select GL Account"
                              data={getGLAccountOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.glAccount || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Delivery Address"
                              name="deliveryAddress"
                              placeholder="Select Delivery Address"
                              data={getDeliveryAddressOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.deliveryAddress || []}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.deliveryAddress}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="purchasingReqRemark"
                              className="inputBox"
                              label="Purchasing Info"
                              name="purchasingReqRemark"
                              placeholder=""
                              value={formInputs.purchasingReqRemark || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="businessJustification"
                              className="inputBox"
                              label="Business Justification"
                              name="businessJustification"
                              // placeholder="Enter Business Justification"
                              value={formInputs.businessJustification || ""}
                              onChange={onInputChange}
                              required={formInputs.budgetAvailability !== "Yes"}
                              error={validation.businessJustification}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex align-items-center"
                          >
                            <div className="form-check mt-4 ms-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="budgetAvailability"
                                name="budgetAvailability"
                                // It is checked if the state says "Yes"
                                checked={
                                  formInputs.budgetAvailability === "Yes"
                                }
                                // onChange={(e) => {
                                //   setFormInputs((prev) => ({
                                //     ...prev,
                                //     budgetAvailability: e.target.checked
                                //       ? "Yes"
                                //       : "No",
                                //   }));
                                // }}
                                onChange={(e) => {
                                  setFormInputs((prev) => ({
                                    ...prev,
                                    budgetAvailability: e.target.checked
                                      ? "Yes"
                                      : "No",
                                  }));
                                  // Justification is only required when budget is NOT available
                                  if (e.target.checked) {
                                    setValidation((prev) => ({
                                      ...prev,
                                      businessJustification: "",
                                    }));
                                  }
                                }}
                                style={{
                                  cursor: "pointer",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor="budgetAvailability"
                                style={{
                                  cursor: "pointer",
                                  fontWeight: "500",
                                  marginTop: "2px",
                                }}
                              >
                                Budget Available
                              </label>
                            </div>
                          </Col>

                          {/* Budget check summary - by Company + Cost Center + Purchase Category */}
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commTopButtonRightLeftPadding"
                          >
                            <div
                              className="d-flex gap-4 flex-wrap align-items-center p-2 rounded mb-1"
                              style={{
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #dee2e6",
                              }}
                            >
                              <span className="fw-bold">Budget Check:</span>
                              {!formInputs?.purchaseCategory ||
                              !formInputs?.companyCode ||
                              !formInputs?.costCenter ? (
                                <span className="text-muted">
                                  Select Company, Cost Center &amp; Purchase
                                  Category to check available budget
                                </span>
                              ) : (
                                <>
                                  <span>
                                    Allocated:{" "}
                                    <b>
                                      {(formInputs?.currency || "INR") +
                                        " " +
                                        budgetAllocated.toLocaleString("en-IN")}
                                    </b>
                                  </span>
                                  <span>
                                    Available:{" "}
                                    <b
                                      style={{
                                        color:
                                          budgetAvailable > 0
                                            ? "#198754"
                                            : "#dc3545",
                                      }}
                                    >
                                      {(formInputs?.currency || "INR") +
                                        " " +
                                        budgetAvailable.toLocaleString("en-IN")}
                                    </b>
                                  </span>
                                  <span>
                                    PR Total:{" "}
                                    <b>
                                      {(formInputs?.currency || "INR") +
                                        " " +
                                        Number(subTotalValue || 0).toLocaleString(
                                          "en-IN",
                                        )}
                                    </b>
                                  </span>
                                  {budgetAvailable > 0 &&
                                  subTotalValue > budgetAvailable ? (
                                    <span className="badge bg-danger">
                                      Budget Exceeded
                                    </span>
                                  ) : budgetAvailable > 0 ? (
                                    <span className="badge bg-success">
                                      Budget Available
                                    </span>
                                  ) : (
                                    <span className="badge bg-secondary">
                                      No Budget Found
                                    </span>
                                  )}
                                </>
                              )}
                            </div>
                            {formInputs?.purchaseCategory &&
                              formInputs?.companyCode &&
                              formInputs?.costCenter &&
                              budgetAvailable > 0 &&
                              subTotalValue > budgetAvailable && (
                                <AlertNotifications
                                  message={[
                                    {
                                      id: 1,
                                      Message: `Budget Exceeded: PR total ${formInputs?.currency ||
                                        "INR"} ${Number(subTotalValue || 0).toLocaleString(
                                        "en-IN",
                                      )} exceeds available budget ${formInputs?.currency ||
                                        "INR"} ${budgetAvailable.toLocaleString(
                                        "en-IN",
                                      )} for ${formInputs?.companyCode}, ${formInputs?.costCenter} & ${formInputs?.purchaseCategory}. Business Justification is required.`,
                                    },
                                  ]}
                                />
                              )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* other  charges table */}
                {false ? (
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible5
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility5}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">DT</span>
                          </Col>

                          <Col xs={4} md={3} lg={3}>
                            <span className="headerTitle">Document Texts</span>
                            <span className="subHeaderTitle">
                              Document texts and Specification{" "}
                            </span>
                          </Col>

                          <Col
                            xs={12}
                            md={8}
                            lg={8}
                            className="headerButtonAlign"
                          >
                            <Col xs={4} md={2} lg={2} className="">
                              <button
                                className="btnTable"
                                onClick={showsetHeaderText}
                              >
                                <i className="bi bi-plus-lg"></i> Add
                              </button>
                            </Col>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible5 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <DataTable
                                // title=""
                                columns={HeaderTextColumns}
                                data={getHeaderTextSelectedData}
                                // progressPending={loading}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                // paginationServer
                                // paginationTotalRows={totalRows}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                selectableRows
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  []
                )}

                {/* Price Shedule / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={3} lg={3}>
                          <span className="headerTitle">Price Schedule</span>
                          <span className="subHeaderTitle">
                            Price Shedule / Line Item
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          {/* <Col xs={4} md={2} lg={2} className="">
                            <button className="btnTable">
                              <i className="bi bi-file-excel"></i> Template
                            </button>
                          </Col> */}
                          {/* <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              onClick={() => {
                                alert("asd");
                              }}
                            >
                              <i className="bi bi-file-excel"></i> Upload
                            </button>
                          </Col> */}
                          <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              onClick={addProductDetails}
                            >
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {" "}
                        {/* dynamicDropdown */}
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              // columns={getPOLineItemsCol}
                              columns={
                                formInputs.purchaseTypeCode === "SER"
                                  ? ServicePOLineItemInitialCol
                                  : formInputs.purchaseTypeCode === "SA"
                                    ? SchedulePOLineItemInitialCol
                                    : POLineItemInitialCol
                              }
                              data={getPOLineItemsData}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      {!loadingDrafts && (
        <>
          <div className="pageFooter mb-4 pb-2">
            <Row className="rowDirection">
              <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  {/* <i className="bi bi-save"></i> Create */}
                  <i className="bi bi-save"></i>{" "}
                  {disabled ? "Creating..." : "Create"}
                </button>
              </Col>
              {/* <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  //  onClick={handleModify}
                >
                  <i className="bi bi-pencil-square"></i> Modify
                </button>
              </Col> */}
            </Row>
          </div>
        </>
      )}

      {/* Material Selection Modal */}
      <MaterialSelectionModal
        show={modalShow}
        onHide={() => hideModal()}
        buyBack={formInputs.buyBack}
        onselectedcatdata={handleGetSelectedMaterial}
        materialType={formInputs?.purchaseTypeCode || ""}
      />

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Header Text"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="POHeaderTextID"
      />

      {/* Price Shedule / Line Item */}
      <HeaderText
        index={getHeaderTextIndex}
        headername="Header Text for Line Item"
        show={getLineItemHeaderTextModal}
        onHide={hideLineItemHeaderText}
        hedertextdata={handleHeaderTextLineItemData}
        showcurrentdata={getDataToHeaderText}
        masterdata="POItemTextID"
      />

      {/* Price Shedule -> Service PO */}
      <SericesSchedulePO
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handleServicePOLineItemData}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs.purchaseTypeCode}
        masterdata="POItemTextID"
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_PURCHASE_REQUISITION_LIST}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default CreatePR;
